<template>
  <div v-if="roles.length > 1">
    <div class="tiered-ac">
      <span>Cambiar rol</span>

    </div>
    <TieredMenu :model="rolesItems"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import localStorage from "@/services/localStorage.service";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["roles"]),
    roleSelected: {
      get() {
        return this.$store.state.role;
      },
      set(val) {
        this.setCurrentRole(val);
      }
    },
    rolesItems: function () {
      return [{
        label: `${this.roleSelected}`,
        icon: 'pi pi-fw pi-user',
        items: this.roles.map((r) => {
          return {
            label: r,
            icon: 'pi pi-fw pi-user',
            command: () => this.setCurrentRole(r)
          }
        })
      }];
    }
  },
  methods: {
    ...mapMutations(["setRole"]),
    setCurrentRole(role) {
      localStorage.setItem("role", role);
      this.setRole(role);
      this.$router.push('/')
      window.location.reload();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/core/Toolbar/RoleSelect.vue